// Korean brand copy. Research fixtures retain their original input and scores.
export const brandKorean: Record<string, string> = {
  "jev-1.13 belongs to Typesafe. Connect AI C1 is our separate Qwen-based fine-tune.": "jev-1.13은 Typesafe의 외부 모델입니다. Connect AI C1은 우리가 별도로 학습한 Qwen 기반 모델입니다.",
  "The phishing emails are synthetic; the tool and routing sets have only 60 and 27 cases. These results describe C1 v0.1 on these sets, not general company-decision ability or future checkpoints.": "피싱 메일은 합성 데이터이고, 도구 위험과 문의 배정은 각각 60건·27건입니다. 이 결과는 해당 문제에서 측정한 C1 v0.1의 기록이며, 기업 판단 전반이나 후속 모델의 성능을 뜻하지 않습니다.",
  "C1 v0.1 / external jev-1.13": "C1 v0.1 / 외부 jev-1.13",
  "C1: open weights for company decisions and physical experiments.": "C1: 기업의 판단과 물리 실험을 위한 공개 AI 모델.",
  "WEIGHTS RELEASED": "가중치 공개",
  "C1 v0.1 · RECORDED RESEARCH": "C1 v0.1 · 기록된 연구",
  "Connect AI C1 v0.1": "Connect AI C1 v0.1",

  "Reinforcement learning, in our context.": "한국형 강화학습 모델 연구",
  "Skip to content": "본문으로 이동",
  "Connect AI home": "Connect AI 홈",
  "Open navigation": "메뉴 열기",
  "Close navigation": "메뉴 닫기",
  "Main navigation": "주요 메뉴",
  "Projects": "프로젝트",
  "Models": "모델",
  "Research": "연구",
  "Tools": "도구",
  "EZERAI tools": "EZERAI 도구",
  "Built with purpose. Connected by people.": "우리의 의지로 만들고, 사람으로 연결합니다.",
  "Building AI we can own, run, and connect—on our own terms.": "우리가 소유하고, 직접 실행하고, 함께 연결하는 AI.",
  "Building AI we can own, run, and connect—": "우리가 소유하고, 직접 실행하고,",
  "on our own terms.": "함께 연결하는 AI.",
  "AN INDEPENDENT AI INITIATIVE": "CONNECT AI / 독립적인 AI를 향해",
  "Follow a decision": "AI의 판단 살펴보기",
  "OWN YOUR INTELLIGENCE.": "우리의 지능을, 우리의 손에.",
  "EXPLORE THE PROJECTS": "프로젝트 둘러보기",
  "BUILT WITH OUR COMMUNITY": "함께 만드는 독립적인 AI",
  "Own the model.": "직접 소유하고.",
  "Run it yourself.": "스스로 실행하고.",
  "Connect by choice.": "자유롭게 연결하고.",
  "THE FUTURE WE’RE BUILDING": "우리가 만드는 미래",
  "CONNECTION STUDY / 001": "연결의 구조 / 001",
  "ILLUSTRATIVE": "개념 시각화",
  "Input": "입력",
  "Connect": "연결",
  "Decide": "판단",
  "A request enters the system.": "하나의 요청에서 시작합니다.",
  "Independent models. Different perspectives.": "각자의 모델, 서로 다른 관점.",
  "Compare the signals. Choose a next step.": "판단을 비교하고, 다음 행동을 선택합니다.",
  "Explore the connection concept": "연결 구조 살펴보기",
  "Pause connection animation": "연결 애니메이션 일시정지",
  "Play connection animation": "연결 애니메이션 재생",
  "01 / INSIDE A DECISION": "01 / 판단의 안쪽",
  "EARLY RESEARCH · BEFORE JEV": "JEV 이전의 기초 연구",
  "A small model.": "작은 모델이",
  "A real next step.": "다음 행동을 고릅니다.",
  "Read the request. Replay the recorded prediction.": "요청을 읽고, 실제 기록된 판단을 확인해 보세요.",
  "Inspect the research": "연구 결과 보기",
  "Explore recorded AI decisions": "기록된 AI 판단 살펴보기",
  "Choose a recorded example": "판단 예시 선택",
  "Human review": "사람의 판단",
  "Payment issue": "결제 오류",
  "Urgent request": "긴급 요청",
  "INCOMING REQUEST": "도착한 요청",
  "EN / TEXT": "KO / 번역",
  "MODEL OUTPUT": "모델의 판단",
  "CHECKPOINT v0.1": "초기 체크포인트 v0.1",
  "Replay progress": "기록 재생 과정",
  "Read example": "요청 확인",
  "Load saved scores": "기록 불러오기",
  "Show prediction": "판단 확인",
  "Replay recorded decision": "기록된 판단 보기",
  "Reset replay": "다시 보기",
  "Replaying saved output": "판단 기록을 불러오는 중",
  "SUGGESTED NEXT STEP": "제안한 다음 행동",
  "TOP PREDICTION": "가장 높은 판단",
  "RECORDED": "기록된",
  "MODEL SCORE": "모델 점수",
  "What happens next?": "어떤 판단을 내렸을까요?",
  "Following the recorded decision.": "기록된 판단을 따라갑니다.",
  "You bring the context. The model suggests a next step.": "맥락을 읽고, 다음에 할 일을 제안합니다.",
  "Playing back an existing research result.": "기존 연구 결과를 재생하고 있습니다.",
  "Recorded output from one early model, not live inference or connected-model performance. Scores are not calibrated certainty. No action is executed.": "영어 입력에 대한 초기 단일 모델의 기록을 한국어로 표시합니다. 실시간 추론이나 연결 모델의 성능이 아니며, 점수는 보정된 확신도가 아닙니다. 실제 행동은 실행하지 않습니다.",
  "I was charged twice for the same course yesterday. Can you check?": "어제 같은 강의가 두 번 결제됐어요. 확인해 주실 수 있나요?",
  "Paid 10 minutes ago but my course page is still empty. My study group starts right now!": "10분 전에 결제했는데 강의실이 아직 비어 있어요. 스터디가 지금 시작해요!",
  "My 14-year-old son bought a course with my credit card without asking. What can I do?": "14살 아들이 허락 없이 제 카드로 강의를 샀어요. 어떻게 해야 하나요?",
  "Congratulations! Your account has won a prize. Click the link below to claim it within 24 hours.": "축하합니다! 경품에 당첨됐어요. 24시간 안에 아래 링크를 눌러 수령하세요.",
  "Hi, the Colab notebook in lesson 3 says 'No module named keras'. What am I doing wrong?": "3강 코랩에서 'No module named keras' 오류가 나요. 무엇이 잘못된 건가요?",
  "Quick idea: it would be nice to have a dark mode for the lesson pages someday.": "아이디어가 있어요. 언젠가 강의 페이지에 다크 모드가 생기면 좋겠어요.",
  "What kind of request is this?": "어떤 종류의 요청일까요?",
  "How urgent is this?": "얼마나 급한 요청일까요?",
  "What should happen next?": "다음에 무엇을 해야 할까요?",
  "Payment error": "결제 오류",
  "Spam": "스팸",
  "Refund": "환불",
  "Right now": "지금 바로",
  "Today": "오늘 중",
  "Later": "나중에",
  "Ask the owner": "사장님께 확인",
  "Owner handles it": "사장님이 처리",
  "Draft for review": "검토할 초안 작성",
  "Account": "계정 문의",
  "Tech question": "기술 질문",
  "This week": "이번 주",
  "View the original English input": "실제 입력: 영어 원문 보기",
  "02 / THE EVOLUTION": "02 / 우리가 걸어온 길",
  "BUILT IN PUBLIC. STILL EVOLVING.": "만드는 과정을 공유하며, 다음으로.",
  "An idea.": "하나의 생각이",
  "In motion.": "다음 프로젝트로.",
  "Run it. Connect it. Build it.": "직접 실행하고. 연결하고. 만들어 갑니다.",
  "Three chapters of Connect AI.": "Connect AI의 세 가지 여정.",
  "Three chapters of Connect AI": "Connect AI의 세 가지 여정",
  "Project history": "프로젝트 히스토리",
  "The application": "로컬 AI 프로그램",
  "The connection": "AI 연결 연구",
  "The decision model": "의사결정 AI 모델",
  "Your second brain.": "나의 두 번째 두뇌,",
  "On your machine.": "내 컴퓨터 안에.",
  "The original Connect AI application. Local AI, personal knowledge, and the tools to put them to work.": "로컬 AI와 나의 지식을 연결한 첫 Connect AI 프로그램. 지금도 내려받아 사용할 수 있습니다.",
  "AVAILABLE NOW": "지금 사용 가능",
  "Explore v1": "프로젝트 보기",
  "Download": "다운로드",
  "Different models.": "서로 다른 모델,",
  "A shared question.": "함께 풀어가는 질문.",
  "Can independent models make better decisions together? Our community’s connection research starts here.": "각자 학습한 모델을 연결하면 더 나은 판단을 할 수 있을까요? 커뮤니티와 함께 실험합니다.",
  "ONGOING RESEARCH": "연구 진행 중",
  "Explore the research": "연구 살펴보기",
  "Enter the Lab": "랩 입장하기",
  "Lab materials require member access.": "랩 자료는 멤버 전용입니다.",
  "Beyond answers.": "답을 넘어,",
  "Toward decisions.": "판단하는 AI로.",
  "Better decisions.": "다음 행동을 고르는 AI.",
  "JEV: a decision-making AI model for AI-native companies. Researching how company context becomes a next action.": "AI-native company의 의사결정을 위한 모델 JEV. 회사의 맥락을 다음 행동으로 바꾸는 AI를 연구합니다.",
  "IN DEVELOPMENT": "개발 중",
  "Explore the model": "모델 살펴보기",
  "THE ORIGINAL RELEASE": "CONNECT AI 최초 공개",
  "Watch the film · Korean": "출시 영상 보기 · 한국어",
  "Watch the original Connect AI release film": "Connect AI 최초 공개 영상 보기",
  "Connect AI original release film": "Connect AI 최초 공개 영상",
  "Original Connect AI release video": "Connect AI 최초 공개 영상 썸네일",
  "RESEARCH CONCEPT": "연구 개념도",
  "03 / THE NEXT FRONTIERS": "03 / 다음 연구의 무대",
  "RESEARCH DIRECTIONS": "연구 방향",
  "Real-world": "현실을 위한",
  "choices.": "판단.",
  "From the work on your screen": "화면 속 나의 일에서",
  "to the world around you.": "우리 주변의 세상까지.",
  "PHYSICAL AI": "PHYSICAL AI",
  "Observe. Decide. Act.": "보고, 판단하고, 움직이고.",
  "Exploring decisions in environments that move.": "변화하는 환경에서 다음 행동을 고르는 AI를 연구합니다.",
  "ONE-PERSON BUSINESSES": "1인 기업을 위한 AI",
  "Your judgment. Extended.": "나의 판단 기준을, AI에게.",
  "Exploring AI that works with your operating rules.": "나만의 운영 규칙과 전문성을 반영하는 AI를 연구합니다.",
  "THE LONG VIEW": "우리가 바라보는 미래",
  "Intelligence.": "우리의 지능을,",
  "In our hands.": "우리의 손에.",
  "Independent minds. Shared possibilities.": "각자의 두뇌를 연결해, 함께 가능성을 넓힙니다.",
  "A future worth building together.": "우리가 직접 만들어 갈 미래입니다.",
  "Why we build": "우리가 만드는 이유",
  "YOUR EXISTING WORKSPACE": "기존 서비스 바로가기",
  "Already using EZERAI?": "EZERAI를 사용하고 계신가요?",
  "All your tools, still here": "기존 도구 모두 보기",
  "Your tools.": "늘 쓰던 도구,",
  "Still right here.": "여기 그대로.",
  "The original Connect AI application and EZERAI tools. Kept here for the people who use them.": "Connect AI 프로그램과 EZERAI의 기존 도구를 계속 사용할 수 있습니다.",
  "Your second brain. Built in public.": "제2의 두뇌를 만들었던 기록.",
  "Download the app": "프로그램 다운로드",
  "Build a local AI agent": "나만의 로컬 AI 에이전트",
  "Build a coding agent": "나만의 코딩 에이전트",
  "Build your second brain": "나의 제2의 두뇌 만들기",
  "Introducing Connect AI": "Connect AI 최초 공개",
  "Watch on YouTube · Korean": "유튜브에서 보기 · 한국어",
  "Filter tools": "도구 종류 선택",
  "All": "전체",
  "Create": "제작",
  "Analyze": "분석",
  "Search tools": "도구 검색",
  "Find a tool…": "필요한 도구를 찾아보세요",
  "No matching tools.": "일치하는 도구가 없습니다.",
  "Try another name or category.": "다른 이름이나 분류로 찾아보세요.",
  "Clear filters": "필터 초기화",
  "Looking for the full original workspace?": "예전 EZERAI 화면을 찾으시나요?",
  "Open Agent University": "기존 화면 열기",
  "Video workflow": "영상 제작 워크플로우",
  "Work with scripts, images, voice, and video.": "대본부터 이미지, 음성, 영상까지 연결합니다.",
  "Your API keys required": "개인 API 키 필요",
  "Simple editor": "간편 편집기",
  "A lighter canvas for creative workflows.": "가볍게 시작하는 제작 워크플로우.",
  "Workflow editor": "워크플로우 편집기",
  "Character studio": "캐릭터 스튜디오",
  "Plan and create character-based emoticons.": "캐릭터 이모티콘을 기획하고 만듭니다.",
  "YouTube topic analyzer": "유튜브 주제 분석기",
  "Explore topics and channel ideas.": "영상 주제와 채널 아이디어를 살펴봅니다.",
  "YouTube & AI keys required": "유튜브·AI API 키 필요",
  "YouTube calculator": "유튜브 수익 계산기",
  "Explore revenue scenarios and assumptions.": "조건에 따른 예상 수익을 살펴봅니다.",
  "Estimates, not earnings guarantees": "추정치이며 실제 수익을 보장하지 않습니다",
  "Christmas card studio": "크리스마스 카드 만들기",
  "Create a personal seasonal card.": "나만의 크리스마스 카드를 만듭니다.",
  "Existing creative tool": "기존 제작 도구",
  "Christmas gallery": "크리스마스 갤러리",
  "Revisit the community card collection.": "함께 만든 카드들을 다시 만나보세요.",
  "Existing gallery": "기존 갤러리",
  "The original EZERAI home, packs, and experiments.": "기존 EZERAI 홈, 팩, 실험 도구를 모았습니다.",
  "Original experience": "기존 서비스",
  "Connect your agent and explore brain packs.": "에이전트를 연결하고 두뇌 팩을 살펴보세요.",
  "Connect AI desktop required": "Connect AI 프로그램 필요",
  "Connect AI LAB extension": "Connect AI LAB 확장 프로그램",
  "The existing development extension.": "기존 개발용 확장 프로그램입니다.",
  "Desktop development tool": "데스크톱 개발 도구",
  "Connect AI desktop": "Connect AI 프로그램",
  "Get the existing desktop application.": "기존 데스크톱 프로그램을 내려받으세요.",
  "A brain of our own.": "우리의 기준으로,",
  "Meet the next chapter.": "다음 AI를 만듭니다.",
  "JEV is our decision-making AI model for AI-native companies. We are exploring reinforcement learning to connect company context, priorities, and next actions.": "AI-native company의 의사결정을 위한 인공지능 모델 JEV를 만듭니다. 한국어와 기업의 맥락을 이해하고, 우선순위와 다음 행동을 고르는 강화학습 모델을 연구합니다.",
  "V3 · IN DEVELOPMENT": "V3 · 개발 중",
  "Understand the context.": "맥락을 이해하고,",
  "Choose the next action.": "다음 행동을 선택합니다.",
  "From local AI to connected models. Now, exploring how AI can turn context and rules into a next-step decision.": "로컬 AI에서 모델의 연결로. 이제는 우리의 규칙과 맥락에 맞춰 판단하는 모델을 연구합니다.",
  "JEV specifications, weights, and evaluations will be published as they are validated.": "JEV의 사양, 가중치, 평가 결과는 검증되는 대로 공개할 예정입니다.",
  "Explore the research foundation": "연구의 출발점 보기",
  "Where the work begins.": "작은 실험에서 시작합니다.",
  "The checkpoint below is earlier research. Its results are not a released JEV model or JEV benchmark.": "아래는 JEV 이전의 초기 실험입니다. 공개된 JEV 모델이나 JEV의 성능 평가가 아닙니다.",
  "Early decision": "의사결정 모델",
  "research": "초기 연구",
  "A compact model exploring how a one-person business can classify requests and choose a next step.": "1인 기업의 요청을 분류하고 다음 단계를 고르는 작은 모델을 실험했습니다.",
  "Qwen3.5-0.8B + LoRA · Weights not yet released.": "Qwen3.5-0.8B + LoRA · 가중치 미공개. JEV 강화학습 연구 이전의 기준 모델입니다.",
  "Explore recorded decisions": "판단 기록 살펴보기",
  "See how it decides.": "어떤 판단을 내렸을까요?",
  "Selected examples · not a live endpoint": "선별된 기록 예시 · 실시간 추론 아님",
  "Measured, with context.": "수치와 한계를 함께 봅니다.",
  "Owner-policy subset accuracy": "운영자 정책 영역 정확도",
  "Overall accuracy · 360 evaluations": "전체 정확도 · 360건 평가",
  "Mean decision time · M5 Max": "평균 판단 시간 · M5 Max",
  "Evaluation notes & limitations": "평가 조건과 한계",
  "These figures come from the local v0.1 evaluation summary dated October 2, 2026. The owner-policy subset baseline for Tev1 was 45%; overall Tev1 accuracy was 44.44%. The recorded English examples above are selected demonstrations, not the benchmark dataset.": "2026년 10월 2일 로컬 v0.1 평가 요약입니다. 비교 모델 Tev1은 운영자 정책 영역 45%, 전체 44.44%였습니다. 위 영어 입력 예시는 선별된 데모로, 평가 데이터셋 자체가 아닙니다.",
  "Results are early and task-specific. The public evaluation dataset, subset count, full runtime configuration, and reproduction instructions have not been released. These numbers do not establish general reasoning ability, production reliability, or performance on other hardware.": "특정 과제에 대한 초기 결과입니다. 평가 데이터셋, 영역별 건수, 전체 실행 환경과 재현 방법은 아직 공개되지 않았습니다. 일반적인 추론 능력이나 운영 안정성, 다른 기기에서의 성능을 의미하지 않습니다.",
  "Use predictions for review. Confidence alone does not guarantee correctness, and the recorded demo does not implement automatic escalation.": "결과는 검토를 위한 참고 자료입니다. 높은 점수가 정답을 보장하지 않으며, 이 데모는 실제 요청을 전달하거나 처리하지 않습니다.",
  "What changes when": "서로 다른 모델을",
  "the models connect?": "연결하면 어떨까요?",
  "Specialization, disagreement, and shared decisions. Evaluated against strong individual models.": "전문성, 의견 차이, 함께 내리는 판단을 강한 단일 모델과 비교해 봅니다.",
  "Connection is a hypothesis.": "연결의 가능성을,",
  "Evidence comes first.": "실험으로 확인합니다.",
  "The second chapter of Connect AI: connecting independently trained models and testing their decisions together.": "각자 학습한 모델을 연결하고, 함께 내리는 판단을 검증하는 Connect AI의 두 번째 프로젝트입니다.",
  "Independent learning.": "학습은 각자의 방식으로,",
  "Connected decisions.": "판단은 함께.",
  "Our starting point: let models keep their own weights and investigate how their decisions can work together.": "각자의 가중치는 유지하면서, 모델의 판단을 어떻게 연결할 수 있는지 연구합니다.",
  "Visit Connect AI LAB": "Connect AI LAB 방문하기",
  "Research materials remain in the members’ Lab.": "연구 자료는 멤버 전용 랩에서 확인할 수 있습니다.",
  "More models. Better decisions?": "모델이 많아지면, 판단도 좋아질까요?",
  "Train independently.": "각자 학습합니다.",
  "Different learning histories and expertise. Preserve the identity of each model.": "서로 다른 학습 경험과 전문성, 모델마다의 특성을 유지합니다.",
  "Connect deliberately.": "연결 방식을 비교합니다.",
  "Compare voting, specialist selection, and cross-checking. Treat disagreement as information.": "투표, 전문가 선택, 교차 검증을 비교하고 의견 차이도 정보로 봅니다.",
  "Test on the unseen.": "새로운 상황에서 검증합니다.",
  "Compare with average and strongest single-model baselines. Measure errors, latency, and cost.": "평균적인 모델과 가장 강한 단일 모델을 기준으로 오류, 지연, 비용을 비교합니다.",
  "Share the limits.": "한계도 공유합니다.",
  "Report when connection helps, when it fails, and what has not been tested.": "연결이 도움이 된 경우, 실패한 경우, 아직 확인하지 못한 것을 기록합니다.",
  "From simulation": "시뮬레이션에서,",
  "to action.": "행동으로.",
  "Explore observation, action selection, and feedback in simulated environments. Real-world hardware capability needs separate validation.": "가상 환경에서 관찰, 행동 선택, 피드백을 실험합니다. 실제 하드웨어 적용에는 별도의 검증이 필요합니다.",
  "No robotics deployment is claimed here.": "현재 실제 로봇 배포를 의미하지 않습니다.",
  "From context": "주어진 맥락에서,",
  "to a decision.": "하나의 판단으로.",
  "Explore classification and next-step predictions informed by operating rules, with people retaining oversight.": "사람의 검토 아래 운영 규칙을 반영한 분류와 다음 행동의 예측을 연구합니다.",
  "View early model results": "초기 모델 결과 보기",
  "A connected system is not automatically a better system. That is what the experiments must establish.": "연결만으로 더 나은 시스템이 되지는 않습니다. 그 차이를 실험으로 확인합니다.",
  "Intelligence we can keep.": "우리가 소유할 지능,",
  "A future we can shape.": "함께 만들어 갈 미래.",
  "We are building toward AI that people can own, run, and connect—on their own terms.": "누구나 자신의 AI를 소유하고, 직접 실행하고, 원하는 방식으로 연결할 수 있는 미래를 만듭니다.",
  "Access should not be": "AI와의 관계가,",
  "our only relationship with AI.": "접속에만 머물지 않도록.",
  "People should be able to retain the models they rely on, run them with compatible tools, and choose how they connect. This is the future Connect AI is working toward.": "의지하는 모델을 직접 보유하고 실행하며, 어떻게 연결할지도 스스로 선택할 수 있어야 합니다. Connect AI가 만들고자 하는 미래입니다.",
  "Our community brings different experiences and expertise. We believe those differences can become a strength—and we are testing when connecting models actually makes a difference.": "커뮤니티의 서로 다른 경험과 전문성을 모델에 담고자 합니다. 그 차이가 연결될 때 어떤 힘이 되는지 함께 검증합니다.",
  "Independence": "독립성은,",
  "is practical.": "실행할 수 있어야 합니다.",
  "Model weights, usable licenses, documented runtimes, and reproducible offline execution. These are milestones to deliver, not promises to assume.": "모델 가중치와 사용 가능한 라이선스, 실행 문서와 재현 가능한 오프라인 환경. 하나씩 갖춰 나가야 할 목표입니다.",
  "Connection": "연결은,",
  "is a choice.": "우리의 선택입니다.",
  "Keep models distinct. Define what is shared. Make the decision process inspectable. Preserve the ability to run independently.": "각 모델의 독립성을 유지하고 무엇을 공유할지 정합니다. 판단 과정을 살펴볼 수 있고, 혼자서도 실행할 수 있어야 합니다.",
  "The original program and its existing tools.": "기존 Connect AI 프로그램과 도구.",
  "Research into connecting independently trained AI models.": "각자 학습한 AI 모델을 연결하는 연구.",
  "JEV: the decision-making AI model we are building next.": "한국형 강화학습 기반 의사결정 모델 JEV 연구.",
  "The community learning and growing independent expertise.": "함께 배우며 각자의 전문성을 키우는 커뮤니티.",
  "The home of this vision and the tools people already use.": "이 비전과 기존 서비스를 함께 담는 공간.",
  "Build a brain.": "나의 모델을 만들고,",
  "Connect. Test. Improve.": "연결하고, 검증합니다.",
  "Follow the research": "연구 따라가기",
  "Choose an example": "예시 선택",
  "Duplicate payment": "중복 결제",
  "Missing course access": "강의 접근 불가",
  "Purchase without permission": "허락 없는 결제",
  "Suspicious prize email": "의심스러운 당첨 메일",
  "Notebook error": "노트북 오류",
  "Feature suggestion": "기능 제안",
  "Recorded business decision examples": "기록된 업무 판단 예시",
  "A small model. One decision at a time.": "작은 모델이, 하나씩 판단합니다.",
  "Recorded model scores, not calibrated certainty. No request is sent or action performed.": "기록된 모델 점수이며 보정된 확신도가 아닙니다. 실제 요청이나 행동은 실행되지 않습니다.",
  "Reset example": "예시 초기화",
  "Reveal recorded decision": "판단 기록 확인",
  "Next example": "다음 예시",
  "The original Connect AI.": "첫 번째 Connect AI.",
  "The v1 application. Choose your platform.": "v1 프로그램입니다. 사용 중인 운영체제를 선택하세요.",
  "Apple silicon": "애플 실리콘",
  "Intel": "인텔",
  "64-bit": "64비트",
  "Latest releases & installation notes ↗": "최신 릴리스·설치 안내 ↗",
  "Same tasks. External reference models.": "같은 문제로, 외부 모델과 비교합니다.",
  "We compared v0.1 on 2,087 public tasks. The external jev and tev1-4B rows are Together AI’s archived results; the three 0.8B rows are local runs on the same task inputs.": "공개 문제 2,087건으로 v0.1을 비교했습니다. 외부 jev와 tev1-4B는 Together AI의 공개 기록, 0.8B 세 모델은 같은 입력으로 실행한 로컬 결과입니다.",
  "jev-1.13 belongs to Typesafe. It is separate from Connect AI’s JEV (v3), which is in development.": "비교 대상 jev-1.13은 Typesafe의 외부 모델입니다. 우리가 개발하는 Connect AI JEV(v3)와는 별개입니다.",
  "Public benchmark accuracy table": "공개 벤치마크 정확도 비교표",
  "Default decision rule: choose the highest-scoring option.": "기본 판단 기준: 가장 높은 점수의 보기 선택",
  "Model": "모델",
  "Runtime": "실행 환경",
  "Phishing": "피싱 판별",
  "Tool risk": "도구 위험도",
  "Ticket routing": "문의 배정",
  "Research checkpoint v0.1": "연구 체크포인트 v0.1",
  "Undisclosed · hosted": "크기 비공개 · 서버",
  "4B · hosted": "4B · 서버",
  "0.8B · local": "0.8B · 로컬",
  "Same task content; different inference wrappers. At the default rule, the external jev scores higher than v0.1 on all three sets.": "문제 내용은 같고 추론 방식은 다릅니다. 기본 기준에서는 외부 jev가 세 평가 모두 v0.1보다 높습니다.",
  "Highest score on each set among the three 0.8B models tested here.": "이번에 비교한 0.8B 세 모델 중, 세 평가 모두 최고점",
  "Tool-risk accuracy on selected cases: 41 correct out of 48, using an option score of at least 0.5.": "보기 점수 0.5 이상인 도구 위험 판단만 선택: 48건 중 41건 정답",
  "Decision coverage: 48 of 60 cases selected; 12 deferred. All-case accuracy is 80.0%.": "판단 비율: 60건 중 48건 선택, 12건 보류. 전체 정확도는 80.0%",
  "Methods, exploratory thresholds, and limits": "평가 방법 · 판단 기준 탐색 · 한계",
  "The three 0.8B models use local MLX option-token scores. The external rows use saved native API responses from the pinned Together repository. This is not a controlled runtime or latency comparison; no training-overlap claim is made.": "0.8B 세 모델은 로컬 MLX의 보기 토큰 점수를 사용합니다. 외부 모델은 Together 저장소에 고정된 API 응답 기록입니다. 실행 환경과 속도를 통제한 비교가 아니며, 학습 데이터와의 비중복도 보장하지 않습니다.",
  "Exploratory phishing threshold analysis": "피싱 판단 기준 탐색 결과",
  "Research checkpoint v0.1 / external jev-1.13": "연구 체크포인트 v0.1 / 외부 jev-1.13",
  "Recalculated from saved scores with fixed seeds 0–29. Each split uses 1,000 emails to choose each model’s accuracy-maximizing threshold and the other 1,000 to evaluate it. The same split is used for both models; ties choose the lowest threshold.": "저장된 점수로 시드 0–29를 고정해 재계산했습니다. 매번 1,000건에서 각 모델의 정확도가 가장 높은 판단 기준을 고르고, 나머지 1,000건으로 평가합니다. 두 모델에 같은 분할을 적용하며, 동률이면 가장 낮은 기준을 고릅니다.",
  "Across these overlapping splits, the baseline is ahead in 30 of 30. Split standard deviations are 1.1 and 1.0 percentage points. These are not 30 independent tests or confidence intervals.": "이 반복 분할에서는 v0.1이 30번 모두 앞섰고, 분할 간 표준편차는 각각 1.1%p와 1.0%p입니다. 같은 데이터가 겹쳐 쓰이므로 독립된 30회 시험이나 신뢰구간을 뜻하지 않습니다.",
  "Threshold tuning changes the trade-off between missed phishing and false alarms. The 0.5 selection rule is also exploratory, not calibrated certainty or a deployed handoff system. New thresholds must be chosen before a fresh company-decision evaluation.": "판단 기준을 바꾸면 놓치는 피싱과 정상 메일 오탐의 비율도 바뀝니다. 점수 0.5 기준 역시 탐색 조건이며, 보정된 확신도나 실제 자동 위임 기능을 의미하지 않습니다. 새 회사 판단 평가에 앞서 별도 데이터로 기준을 정해야 합니다.",
  "Five of the baseline’s six routing errors were incorrect spam assignments. Include legitimate requests mentioning spam in the next training set, while keeping evaluation examples separate.": "문의 배정 오답 6건 중 5건은 정상 문의를 스팸으로 보낸 경우입니다. 스팸을 언급하는 정상 문의를 학습 반례에 넣고, 평가 예시는 따로 보존할 계획입니다.",
  "The phishing emails are synthetic; the tool and routing sets have only 60 and 27 cases. These results describe this pre-JEV checkpoint on these sets, not general company-decision ability or Connect AI JEV v3 performance.": "피싱 메일은 합성 데이터이고, 도구 위험과 문의 배정은 각각 60건·27건의 작은 평가입니다. 이 결과는 해당 문제에서 측정한 JEV 이전 체크포인트의 기록이며, 기업 판단 전반이나 Connect AI JEV v3의 성능이 아닙니다.",
  "Evidence and reproducibility": "근거와 재현 자료",
  "Pinned public source": "고정된 원출처",
  "Counts and method · JSON": "건수·평가 방법 JSON",
  "Local predictions · JSON": "로컬 예측 기록 JSON",
  "Reproduction script": "재현 코드",
  "What we improve next.": "다음은, 회사 판단의 정밀도.",
  "PLANNED RESEARCH": "다음 연구 계획",
  "Counterexamples first.": "스팸 반례부터",
  "Add legitimate messages that mention spam, and distinguish the request from the words it contains.": "스팸을 언급하는 정상 문의를 더해, 단어와 실제 요청을 구분하도록 학습합니다.",
  "Broader company decisions.": "더 넓은 회사 판단",
  "Expand product, customer, and operations examples, with task boundaries and data licenses checked.": "제품·고객·운영 판단 데이터를 넓히고, 과제 범위와 데이터 라이선스를 확인합니다.",
  "Validate decision thresholds.": "판단 기준 검증",
  "Set task-specific thresholds on separate tuning data. Test accuracy, false alarms, and deferrals on a fresh holdout.": "별도 데이터로 업무별 기준을 정하고, 새로운 평가셋에서 정확도·오탐·보류 비율을 확인합니다.",
  "The goal is better company decisions. Improvement will be measured on new data, not assumed from this comparison.": "목표는 더 정확한 회사 판단입니다. 개선 여부는 새로운 데이터로 검증합니다.",
  "RESEARCH IN PROGRESS": "연구 진행 중",
  "A brain for": "기업의 판단을,",
  "company decisions.": "학습하는 두뇌.",
  "Learning how to choose the next action. Researching reinforcement learning grounded in Korean language and company context.": "한국어와 기업의 맥락을 이해하고, 다음 행동을 고르는 강화학습 모델을 연구합니다.",
  "Inside the research": "연구 살펴보기",
  "Company decisions": "기업의 의사결정",
  "Korean context": "한국어와 우리의 맥락",
  "Reinforcement learning research": "강화학습 연구",
  "JEV research chapters": "JEV 연구 목차",
  "The starting point.": "현재의 실험",
  "Evidence, in the open.": "검증의 기록",
  "Better company decisions.": "다음 연구",
  "2,087 tasks · 5 models": "공개 문제 2,087건 · 모델 5개",
  "Company checkpoint v0.2 · planned": "회사 판단용 v0.2 · 계획",
  "Scroll across to compare": "옆으로 넘겨 비교해 보세요",
};
